export const iconFontAwesomeTextformattingAlignLeft = (
	<i className="fa-solid fa-align-left"></i>
);
